module.exports = __webpack_public_path__ + "img/empilhadeiras_pag8.d281c4a8.jpg";